import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Send a GA4 event via the global gtag function.
 * Silently no-ops when gtag is unavailable (ad-blockers, test environments).
 */
export function trackEvent(eventName, params = {}) {
  if (typeof window.gtag === "function") {
    window.gtag("event", eventName, params);
  }
}

/**
 * Hook: fires a GA4 page_view on every React Router location change.
 * Must be rendered inside <BrowserRouter>.
 */
export function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    trackEvent("page_view", {
      page_path: location.pathname + location.search,
      page_title: document.title,
    });
  }, [location]);
}
